/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable operator-linebreak */
import React, { useMemo, useState } from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { colors } from "common";
import { Theme, useTheme } from "@mui/material/styles";
import BuildGalleryTags from "./BuildGalleryTags";
import { BuildsGalleryPrice } from "./BuildsGalleryPrice";
import BazarImage from "components/BazarImage";

const useStyles = makeStyles(
  (theme: Theme) => ({
    btnsContainer: {
      display: "flex",
      marginTop: theme.spacing(2),
    },
    badgeImg: {
      width: undefined,
      height: 20,
      marginRight: theme.spacing(1),
    },
    titleContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    titleTxt: {
      fontWeight: 600,
      fontSize: 14,
      letterSpacing: 0.5,
      display: "-webkit-box",
      overflow: "hidden",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: 1,
    },
    divider: {},
    imgContainer: {
      position: "relative",
    },
    cpuContainer: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: 80,
      borderTopRightRadius: 3,
      padding: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "1px solid white",
    },
  }),
  { index: 999 }
);

const component = ({ data, onClick }) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [badgeImgErr, setBadgeImgErr] = useState("");
  const [coverImgErr, setCoverImgErr] = useState("");

  const bgColorOFCpuContainer = useMemo(() => {
    if (data) {
      if (data.cpu === "Intel") {
        return "#0068B5";
      }
      if (data.cpu === "AMD") {
        return "#FC5C00";
      }
    }
    return colors.primary;
  }, [data]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const placeHolderTags = ["PC", "WORTH", "LANG", "SAKALAM"];

  const buildTags = useMemo(() => {
    if (data && data.build_tags && data.build_tags.length > 0) {
      return data.build_tags;
    }
    return placeHolderTags;
  }, [data, placeHolderTags]);

  return (
    <Card
      elevation={1}
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minWidth: "100%",
        width: "250px",
      }}
    >
      <CardActionArea href={`/builds-gallery/details/${data?.uuid}`}>
        <div className={classes.imgContainer}>
          <CardMedia
            component="img"
            sx={{
              width: "100%",
              height: "200px", 
              objectFit: "cover",
            }}
            image={
              data.cover_thumbnail ||
              data.cover ||
              coverImgErr ||
              "/static/images/logo.png"
            }
            alt={data.title || "cover"}
            onError={() => setCoverImgErr("/static/images/logo.png")}
          />

          {data.cpu ? (
            <div
              className={classes.cpuContainer}
              style={{ backgroundColor: bgColorOFCpuContainer }}
            >
              <Typography color="white" fontWeight={600}>
                {data.cpu}
              </Typography>
            </div>
          ) : null}
        </div>

        <CardContent
          sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
        >
          <div className={classes.titleContainer}>
            {data.badge ? (
              <BazarImage
                alt="badge"
                className={classes.badgeImg}
                src={badgeImgErr || data.badge || "/static/images/logo.png"}
                onError={() => setBadgeImgErr("/static/images/logo.png")}
              />
            ) : null}
            <Typography className={classes.titleTxt}>{data.title}</Typography>
          </div>
          <Typography variant="caption" color="gray" fontSize={10}>
            {data.created_date || ""}
          </Typography>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              marginTop: 10,
              justifyContent: "flex-start",
              alignItems: "flex-start",
              overflow: "hidden",
              flexGrow: 1,
            }}
          >
            {buildTags.map((tag, i) => (
              <BuildGalleryTags key={`${i}${tag}`} title={tag} />
            ))}
          </div>

          <BuildsGalleryPrice data={data} />
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export const BuildGalleryListItem = React.memo(component);
